import React from 'react'
import './index.scss'

const StripeButtons = ({ btns = [] }) => {
  const renderButtons = () => {
    const rButtons = btns.map(({ id, label, action, classNames }) => {
      return (
        <div id={id} className={classNames} onClick={action}>
          {label}
        </div>
      )
    })

    return rButtons
  }

  return (
    <div class='button-container'>
      <div className='button-container-item'></div>
      {renderButtons()}
    </div>
  )
}

export default StripeButtons
